/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { type IUserAuth, type TramiteEstadoContratacion } from '@/interfaces/model/user.interface';

type UserState = {
	// Variables
	user?: IUserAuth;
	tramiteSeleccionado: number;

	// Acciones
	setUser: (user: IUserAuth | undefined) => void;
	setTramiteSeleccionado: (val: number) => void;
	getTramiteData: () => TramiteEstadoContratacion;
	getTramitesContratados: () => TramiteEstadoContratacion[];
	clean: () => void;
};

export const useSessionStore = create(
	persist<UserState>(
		(set, get) => ({
			// Estado Inicial
			user: undefined,
			tramiteSeleccionado: 0,

			setUser: (user) => set({ user }),

			setTramiteSeleccionado: (val) => set({ tramiteSeleccionado: val }),

			getTramitesContratados() {
				const { user } = get();
				return user?.listaTramitesEstadoContratacion.filter(({ contratado }) => Boolean(contratado)) ?? [];
			},

			getTramiteData() {
				const { user, tramiteSeleccionado } = get();
				return user?.listaTramitesEstadoContratacion.find(
					({ tipoTramite }) => tipoTramite.id === tramiteSeleccionado,
				) as TramiteEstadoContratacion;
			},

			clean() {
				set({ user: undefined, tramiteSeleccionado: 0 });
				sessionStorage.removeItem('user-storage');
			},
		}),
		{
			name: 'session-storage', // Nombre único para este store
			storage: createJSONStorage(() => sessionStorage),
			partialize: (state) =>
				({
					user: state.user,
					tramiteSeleccionado: state.tramiteSeleccionado,
				}) as UserState,
		},
	),
);
